import { MenuNode } from './MenuNode';
import { Helper } from './Helper';
import { BaseSensor } from './BaseSensor';
export class Generator{

	public static DiagnoseCodes(){
		console.log("Generator: Generating menues.");
		let ts = MenuNode.getTranslator();
		if(ts === undefined){
			console.error("Translator-Service not yet defined.");
			return;
		}

		let nodes = new Array<MenuNode>();

		let settableDiagnoseCodes = ["000","001","002","014","017","018","019","020","026","027","028","031","043","045","050","051","052","058","062","071","072","073","074","075","076","077","078","084","085","088","093","094","096","126","128","129","132","145","146","147","156","157","158","159","160","161","162","163","164","170","171","172","173","174","175"];
		let ignoreDiagnoseCodes = ["014","019","024","044","030","032","037","038","042","046","048","049","053", "070", "086","091","099","103","122","123", "124", "126", "127", "181"];
		let sensorConfigs = {
			'd000':{
				'unit':'AICI_UNIT_KW',
				'list':['Auto','2.5','3.0','4.0','5.0','6.0','7.0','8.0','9.0','10.0','11.0','12.0','13.0','14.0','15.0','16.0','17.0','18.0','19.0','20.0','21.0','22.0','23.0','24.0','25.0','26.0','27.0','28.0','29.0','30.0','31.0','32.0','33.0','34.0','35.0','35.2']
			},
			'd001':{
				'unit':'AICI_UNIT_MINUTE',
				'min':1,
				'max':60,
				'gran':1,
				'cur':5,
			},
			'd002':{
				'unit':'AICI_UNIT_MINUTE',
				'min':1,
				'max':60,
				'gran':1,
				'cur':20,
			},
			'd003':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':1,
				'max':100,
				'gran':1,
				'cur':30,
			},
			'd004':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':1,
				'max':100,
				'gran':1,
				'cur':60,
			},
			'd005':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':1,
				'max':100,
				'gran':1,
				'cur':73
			},
			'd006':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':34,
				'max':60,
				'gran':1,
				'cur':60,
			},
			'd007':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':40,
				'max':65,
				'gran':1,
				'cur':60,
			},
			'd008':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd009':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':0,
				'max':100,
				'gran':1,
				'cur':73
			},
			'd010':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd011':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd012':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd013':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd014':{
					'unit':'',
					'list':['0','1','2','3','4','5']	
			},
			'd015':{
				'unit':'AICI_UNIT_PERCENT',
				'min':0,
				'max':100,
				'gran':1,
				'cur':100
			},
			'd016':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd017':{
				'unit':'',
				'list':['OFF','On'],
				'info':'OFF: {{tr:DELIGHT_DIA_CODE_ID_017_VALUE_0}}\nOn: {{tr:DELIGHT_DIA_CODE_ID_017_VALUE_1}}'
			},
			'd018':{
				'unit':'',
				'list':['1','3'],
				'info':'1: {{tr:DELIGHT_DIA_CODE_ID_018_VALUE_1}}\n3: {{tr:DELIGHT_DIA_CODE_ID_018_VALUE_3}}'
			},
			'd019':{
					'unit':'',
					'list':['1','2','3','4']	
			},
			'd020':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':50,
				'max':65,
				'gran':1,
				'cur':65
			},
			'd021':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd022':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd023':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd024':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd025':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd026':{
				'unit':'',
				'list':['2','3','4','5','6','7','8','9','10','1'],
				'info':"1: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_3}}\n4: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_4}}\n5: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_5}}\n6: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_6}}\n7: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_7}}\n8: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_8}}\n9: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_9}}\n10: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_10}}"
			},
			'd027':{
				'unit':'',
				'list':['2','3','4','5','6','7','8','9','10','1'],
				'info':"1: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_3}}\n4: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_4}}\n5: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_5}}\n6: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_6}}\n7: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_7}}\n8: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_8}}\n9: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_9}}\n10: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_10}}"
			},
			'd028':{
				'unit':'',
				'list':['2','3','4','5','6','7','8','9','10','1'],
				'info':"1: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_3}}\n4: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_4}}\n5: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_5}}\n6: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_6}}\n7: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_7}}\n8: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_8}}\n9: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_9}}\n10: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_10}}"
			},
			'd029':{
				'unit':'',
				'list':['20']
			},
			'_d029':{
				'unit':'STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT',
				'min':0,
				'max':1000,
				'gran':1,
				'cur':660
			},
			'd031':{
				'unit':'',
				'list':['0','1','2'],
				'info':"0: {{tr:DELIGHT_DIA_CODE_ID_031_VALUE_0}}\n1: {{tr:DELIGHT_DIA_CODE_ID_031_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_031_VALUE_2}}"
			},
			'd033':{
				'unit':'AICI_UNIT_ROTATIONSPERMINUTE',
				'min':0,
				'max':1000,
				'gran':1,
				'cur':0
			},
			'd034':{
				'unit':'AICI_UNIT_ROTATIONSPERMINUTE',
				'min':0,
				'max':1000,
				'gran':1,
				'cur':0
			},
			'd035':{
				'unit':'AICI_UNIT_PERCENT',
				'list':['0','1','2']
			},
			'd036':{
				'unit':'STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT',
				'min':0,
				'max':1000,
				'gran':1,
				'cur':0
			},
			'd039':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':50,
				'max':70,
				'gran':1,
				'cur':50
			},
			'd040':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':50,
				'max':70,
				'gran':1,
				'cur':50
			},
			'd041':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':50,
				'max':70,
				'gran':1,
				'cur':40
			},
			'd043':{
				'unit':'',
				'min':0.1,
				'max':4,
				'gran':0.1,
				'cur':1.2
			},
			'd044':{
				'unit':'',
				'min':0.1,
				'max':4,
				'gran':0.1,
				'cur':1
			},

			'd045':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':15,
				'max':30,
				'gran':1,
				'cur':15
			},
			'd047':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':15,
				'max':30,
				'gran':1,
				'cur':15
			},
			'd050':{
				'unit':'AICI_UNIT_ROTATIONSPERMINUTE',
				'min':0,
				'max':3000,
				'gran':10,
				'cur':0
			},
			'd051':{
				'unit':'AICI_UNIT_ROTATIONSPERMINUTE',
				'list':[]
			},
			'd052':{
				'unit':'',
				'min':10,
				'max':188,
				'gran':1,
				'cur':130
			},
			'd058':{
				'unit':'',
				'list':['0','1','2','3','4','5'],
				'info':"0: {{tr:DELIGHT_DIA_CODE_ID_058_VALUE_0}}\n1: {{tr:DELIGHT_DIA_CODE_ID_058_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_058_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_058_VALUE_3}}\n4: {{tr:DELIGHT_DIA_CODE_ID_058_VALUE_4}}\n5: {{tr:DELIGHT_DIA_CODE_ID_058_VALUE_5}}"
			},
			'd060':{
				'unit':'',
				'min':0,
				'max':70,
				'gran':1,
				'cur':0
			},
			'd061':{
				'unit':'',
				'min':0,
				'max':70,
				'gran':1,
				'cur':0
			},
			'd062':{
				'unit':'AICI_UNIT_KELVIN',
				'min':0,
				'max':16,
				'gran':1,
				'cur':0
			},
			'd064':{
				'unit':'AICI_UNIT_SECOND',
				'min':0,
				'max':10,
				'gran':0.1,
				'cur':0
			},
			'd065':{
				'unit':'AICI_UNIT_SECOND',
				'min':0,
				'max':10,
				'gran':0.1,
				'cur':0
			},
			'd067':{
				'unit':'AICI_UNIT_MINUTE',
				'min':0,
				'max':60,
				'gran':1,
				'cur':0
			},
			'd068':{
				'unit':'',
				'min':0,
				'max':999,
				'gran':1,
				'cur':0
			},
			'd069':{
				'unit':'',
				'min':0,
				'max':999,
				'gran':1,
				'cur':0
			},
			'd070':{
				'list':['DELIGHT_DIA_CODE_ID_070_VALUE_0','DELIGHT_DIA_CODE_ID_070_VALUE_1'],
				'unit':'',
			},
			'd071':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':40,
				'max':80,
				'gran':1,
				'cur':75
			},
			'd072':{
				'unit':'AICI_UNIT_MINUTE',
				'min':0,
				'max':10,
				'gran':1,
				'cur':2
			},
			'd073':{
				'unit':'AICI_UNIT_KELVIN',
				'list':['0.0','1.0','2.0','3.0','4.0','5.0','-15.0','-14.0','-13.0','-12.0','-11.0','-10.0','-9.0','-8.0','-7.0','-6.0','-5.0','-4.0','-3.0','-2.0','-1.0']
			},
			'd074':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd075':{
				'unit':'AICI_UNIT_MINUTE',
				'min':20,
				'max':90,
				'gran':1,
				'cur':45
			},
			'd077':{
				'unit':'AICI_UNIT_KW',
				'list':['24.0','2.7','3.0','4.0','5.0','6.0','7.0','8.0','9.0','10.0','11.0','12.0','13.0','14.0','15.0','16.0','17.0','18.0','19.0','20.0','21.0','22.0','23.0']
			},
			'd078':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':50,
				'max':80,
				'gran':1,
				'cur':75
			},
			'd080':{
				'unit':'AICI_UNIT_HOUR',
				'min':0,
				'max':999,
				'gran':1,
				'cur':0
			},
			'd081':{
				'unit':'AICI_UNIT_HOUR',
				'min':0,
				'max':999,
				'gran':1,
				'cur':0
			},
			'd082':{
				'unit':'',
				'min':0,
				'max':999,
				'gran':1,
				'cur':0
			},
			'd083':{
				'unit':'',
				'min':0,
				'max':999,
				'gran':1,
				'cur':0
			},
			'd084':{
				'unit':'AICI_UNIT_HOUR',
				'min':-100,
				'max':7000,
				'gran':100,
				'cur':2400
			},
			'd085':{
				'unit':'AICI_UNIT_KW',
				'list':['2.7','3.0','4.0','5.0','6.0','7.0','8.0','9.0','10.0','11.0','12.0','13.0','14.0','15.0','16.0','17.0','18.0','19.0','20.0','21.0','22.0','23.0','24.0']
			},
			'd088':{
				'unit':'',
				'list':['0','1'],
				'info':"0: {{tr:DELIGHT_DIA_CODE_ID_088_VALUE_0}}\n1: {{tr:DELIGHT_DIA_CODE_ID_088_VALUE_1}}"
			},
			'd090':{
				'unit':'',
				'list':['OFF','On'],
				'info':'OFF: {{tr:DELIGHT_DIA_CODE_ID_090_VALUE_0}}\nOn: {{tr:DELIGHT_DIA_CODE_ID_090_VALUE_1}}'
			},
			'd091':{
				'unit':'',
				'list':['0','1','2'],
				'info':'0: {{tr:DELIGHT_DIA_CODE_ID_091_VALUE_0}}\n1: {{tr:DELIGHT_DIA_CODE_ID_091_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_091_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_091_VALUE_3}}',
			},
			'd092':{
				'unit':'',
				'list': ['0','1','2'],
				'info':'0: {{tr:DELIGHT_DIA_CODE_ID_092_VALUE_0}}\n1: {{tr:DELIGHT_DIA_CODE_ID_092_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_095_VALUE_2}}'
			},
			'd093':{
				'unit':'',
				'min':0,
				'max':300,
				'gran':1,
				'cur':161
			},
			'd094':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL'],
			},
			'd095':{
				'list':['0376.04.04','0373.04.03'],
				'unit':''
			},
			'd096':{
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL'],
				'unit':''
			},
			'd098':{
				'unit':'',
				'list':['06.05']
			},
			'd122':{
				'unit':'',
				'min':100,
				'max':400,
				'gran':1,
				'cur':100
			},
			'd125':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':0,
				'max':30,
				'gran':1,
				'cur':0
			},
			'd126':{
				'unit':'AICI_UNIT_MINUTE',
				'min':0,
				'max':30,
				'gran':1,
				'cur':0
			},
			'd128':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':15,
				'max':75,
				'gran':1,
				'cur':30
			},
			'd129':{
				'unit':'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min':35,
				'max':65,
				'gran':1,
				'cur':35
			},
			'd132':{
				'unit':'',
				'min':2,
				'max':7,
				'cur':2,
				'gran':1,
				'infoId':99
			},
			'd145':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd146':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd147':{
				'unit':'',
				'list':['DELIGHT_DIA_CODE_ID_147_VALUE_0','DELIGHT_DIA_CODE_ID_147_VALUE_1']
			},
			'd156':{
				'unit':'',
				'list':['AICI_OFF_NORMAL','AICI_ON_NORMAL']
			},
			'd157':{
				'unit':'',
				'list':['DELIGHT_DIA_CODE_ID_157_VALUE_1','DELIGHT_DIA_CODE_ID_157_VALUE_2']
			},
			'd158':{
				'unit':'',
				'min':-127,
				'max':128,
				'cur':1,
				'gran':1
			},
			'd159':{
				'unit':'',
				'list':['AICI_ON_NORMAL','AICI_OFF_NORMAL']
			},
			'd160':{
				'unit':'STD_UNIT_BAR_NORMAL_LEFT',
				'min':0,
				'max':3,
				'gran':0.1,
				'cur':1
			},
			'd161':{
				'unit':'',
				'time':'serviceDate'
			},
			'd162':{
				'unit':'',
				'list':['DELIGHT_DIA_CODE_ID_162_VALUE_0','DELIGHT_DIA_CODE_ID_162_VALUE_1']
			},
			'd163':{
				'unit':'',
				'list':['0','1'],//,2,3,4,5,6,7,8,9,10],
				'info':"0: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_11}}\n1: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_1}}"
				//'info':"1: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_1}}\n2: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_3}}\n4: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_4}}\n5: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_5}}\n6: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_6}}\n7: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_7}}\n8: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_8}}\n9: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_9}}\n10: {{tr:DELIGHT_DIA_CODE_ID_026_VALUE_10}}"
			},
			'd164':{
				'unit':'AICI_UNIT_PERCENT',
				'min':-5,
				'max':5,
				'gran':1,
				'cur':0
			},
			'd170':{
				'unit':'',
				'list':['0','1','2','3','4'],
				'info':"2: {{tr:DELIGHT_DIA_CODE_ID_170_VALUE_2}}\n3: {{tr:DELIGHT_DIA_CODE_ID_170_VALUE_3}}\n4: {{tr:DELIGHT_DIA_CODE_ID_170_VALUE_4}}"
			},
			'd171':{
				'unit':'AICI_UNIT_MBAR',
				'min':100,
				'max':400,
				'gran':10,
				'cur':200
			},
			'd172':{
				'unit':'AICI_UNIT_KELVIN',
				'min':10,
				'max':20,
				'gran':1,
				'cur':20
			},
			'd173':{
				'unit':'AICI_UNIT_MBAR',
				'min':100,
				'max':400,
				'gran':50,
				'cur':200
			},
			'd174':{
				'unit':'AICI_UNIT_MBAR',
				'min':100,
				'max':400,
				'gran':50,
				'cur':400
			},
			'd175':{
				'unit':'AICI_UNIT_PERCENT',
				'min':50,
				'max':100,
				'gran':10,
				'cur':100
			},
			'd9999':{
				'tag':'Einstellbare Heizbelastung',
				'unit':'AICI_UNIT_KWH',
				'list':['3.0','4.0','5.0','6.0','7.0','8.0','9.0','10.0','11.0','12.0','13.0','14.0','15.0','16.0','17.0','18.0','19.0','20','21','22','23','24']
			},
			'd9998':{
				'tag':'Restförderhöhe',
				'unit':'AICI_UNIT_MBAR',
				'min':100,
				'max':400,
				'gran':10,
				'cur':200
			},
			'd9997':{
				'tag':'ist das die korrekte gasart?',
				'unit':'',
				'list':['AICI_YES_NORMAL','AICI_NO_NORMAL']
			}
		};
        let configService = MenuNode.getDataIoService().getConfiguration();
        if(configService.getConfigPrefix() == 'de'){
        	ignoreDiagnoseCodes.push('162');
        }
        
		let sc = MenuNode.getDataIoService().getConfiguration().simulatorConfig;
		if(sc.getVariant() == 'ecoTEC plus'|| sc.isSDBG()){
			sensorConfigs.d170.list.shift();
			sensorConfigs.d170.list.shift();
		}
		let di = MenuNode.getDataIoService().getDeviceInfo();
		0 -10 -20
		for(let i=0;i<=99;i++){
			sensorConfigs.d051.list.push( (-i*10)+"");
		}
		sensorConfigs.d051.list.push( "-999");
		
		for(let name of Object.keys(sensorConfigs)){
			let s : BaseSensor = null;
			let data = sensorConfigs[name];
			if(data['list']){
				s = new BaseSensor();
				s.setList(data['list']);
				s.setUnit(data['unit']);
				s.setCurrentValue(0);
			}else{
				s = BaseSensor.fromArgs(name,data['cur'],data['min'],data['max'],data['gran'],data['unit']);
			}
			if(name == 'd084'){
				s.setSpecialValue(-100,"OFF");
			}
			if(name == 'd006'){
				s.setSpecialValue(34,"oFF","oFF")
			}
			if(name == 'd020'){
				s.registerHook( 'valueChanged', 
					(newVal)=>{
						let d006 = di.getScale('d006');
						if(d006.getCurrentValue()>newVal){
							d006.setCurrentValue(newVal);
						}
						d006.setMaxValue(newVal);});
			}
			if(name == 'd096'){
				s.registerHook( 'valueChanged', function(newVal){
					if(newVal == 1){
						MenuNode.getDataIoService().reset().then(
							(data)=>{
								MenuNode.getDataIoService().inputs.goto('installationsroutine');
							}
						);
					}
				});
			}
			if(name == 'd094'){
				s.registerHook( 'valueChanged', 
					function(newVal){
						if(newVal == 1){
							s.setCurrentValue(0);
						}
					}
				);
			}
			s.setName(name);
			di.setScale(name,s);
		}
		
		
		for(let i=0;i<200;i++){

			let id = Helper.threeDigits(i);
			if(ignoreDiagnoseCodes.includes(id)){
				continue;
			}
			let key :string = "DELIGHT_DIA_CODE_ID_"+id;
			if(!ts.has(key)){
				if(sensorConfigs['d'+id]){
					key=id;
				}else{
					continue;
				}
			}


  			let title = 'D.'+Helper.threeDigits(i)+"\n{{tr:"+key+"}}|{{get:deviceinfo.d"+id+".toString}}";
			let nodeData = {
				'title':title,
				'type':'menuentry',
				'id':"diagnoseCode."+id,
				'target':'goto:child:0'
			}


			let editable :boolean = settableDiagnoseCodes.includes(id);
			if(['095','161'].includes(id)){
					if(undefined === nodeData['template_parameter']){
						nodeData['template_parameter'] = 'autoScroll';
					}else{
						nodeData['template_parameter'] += ',autoScroll';
					}	
			}
			if(sensorConfigs['d'+id] && sensorConfigs['d'+id]['infoId'] != undefined){
				nodeData['infoId']=sensorConfigs['d'+id]['infoId'];
			}
			if(sensorConfigs['d'+id] && sensorConfigs['d'+id]['info'] != undefined){
				nodeData['infoText']=sensorConfigs['d'+id]['info'];
			}
			
			let node = new MenuNode(nodeData);
			if(editable){
				let childData = {
					'title':'D.'+Helper.threeDigits(i),
					'template':(editable?'settingsvalue':'showvalue'),
					'text':[key],
					'type':(id=='161'?'servicedate':'temperature'),
					'template_parameter':(editable?'circular,smallValue':'smallValue'),
					'buttons':(editable?'back,up,down,confirm':'back'),
					'onConfirm':'set:deviceinfo.d'+id,
					'target':'goto:diagnoseCodeMenu',
					'back':'goto:diagnoseCodeMenu'
				}
				if(id == '095'){
					childData['template_parameter']+= ',autoScroll';
				}
				node.addChild(new MenuNode(childData));
			}
			nodes.push(node);
		}

		return nodes;
	}












	public static DataOverview(){
		let ts = MenuNode.getTranslator();
		if(ts === undefined){
			console.error("Translator-Service not yet defined.");
			return;
		}
		let elements=[
		]
		let nodes = new Array<MenuNode>();
		let status = '31';
		let statusCode = Helper.threeDigits(status);
		let translationUnits = [];

		let end = false;
		for(let i=1;i<256 && !end;i++){
			let trId = 'DELIGHT_STATUS_ID_'+statusCode+'_DETAILS_'+i;
			if(ts.has(trId)){
				translationUnits.push(trId);
			}else{
				end=true;
			}
		}
		let key = "S."+status;
		let value = "";

		for(let trId of translationUnits){
			value +=ts.tr(trId);
			if(trId != translationUnits[translationUnits.length-1]){
				value+="\n"
			}
		}
        
		elements.push(key+'|'+value);
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_WATER_PRESSURE}}|{{get:zone.default.sensor.pressure.water.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_MODULATION}}|{{get:zone.default.sensors.misc.currentModulation.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_TARGETFLOW_TEMP}}|{{get:heatingCircuit.1.vorlaufsolltemp.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_FLOW_TEMP}}|{{get:heatingCircuit.1.vorlaufisttemp.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_RETURN_TEMP}}|{{get:deviceinfo.d041.toString}}')
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_DHW_SETPOINT}}|{{get:deviceinfo.d006.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_HOTWATER_TEMPERATURE}}|{{get:heatingCircuit.1.warmwassertemperatur.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_TANK_TEMPERATURE}}|{{get:heatingCircuit.1.speicher_ist_temperatur.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_DHW_FLOWRATE}}|{{get:deviceinfo.d036.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_CH_FLOWRATE}}|{{get:deviceinfo.d029.toString}}');
		// restförderhöhe
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_PRESSURE_HEAD}}|{{get:deviceinfo.d171.toString}}');
		//stellung 3-wege
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_3WAY_VALVE_POS}}|{{get:deviceinfo.d035.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_ACTUAL_FAN_SPEED}}|{{get:deviceinfo.d034.toString}}');
		for(let element of elements){
			let d = {
				"title": element,
	            "type": "menuentry",
	        };
	        if(d.title.indexOf('DELIGHT_DATAOVERVIEW_PRESSURE_HEAD') != '-1'){
	        	d['id']="dataOverView.DELIGHT_DATAOVERVIEW_PRESSURE_HEAD";
	        }
            nodes.push(new MenuNode(d));
        }
		return nodes;
	}

}